import styled from 'styled-components'
import { ReactElement, useState } from 'react'
import { Button, Grid, H, P, Wrapper } from '@farewill/ui'
import { FONT, GTR } from '@farewill/ui/tokens'

import CrematoriumInput from 'components/form/crematorium-input'
import { Crematorium } from 'lib/models/crematorium'

export const StyledInputMethodButton = styled(Button)`
  text-decoration: underline;
  font-weight: ${FONT.WEIGHT.REGULAR};
  font-size: ${FONT.SIZE.M};

  &:hover {
    text-decoration: underline;
  }
`

const CrematoriumDetails = styled(Wrapper)`
  display: flex;
  align-items: flex-start;
  gap: ${GTR.XXS};
  margin-bottom: ${GTR.S};

  &::before {
    content: '';
    display: block;
    flex-shrink: 0;
    width: 1.5em;
    height: 1.5em;
    background: url('/images/pin.svg') no-repeat center;
    background-size: contain;
  }
`

const CrematoriumText = styled(Wrapper)`
  flex: 1;
`

const CrematoriumName = styled(Wrapper)`
  flex: 1;
  display: block;
  width: 100%;
  font-weight: ${FONT.WEIGHT.MEDIUM};
`

const CrematoriumAddress = styled(Wrapper)`
  flex: 1;
  display: block;
  width: 100%;
`

export type CrematoriumPickerProps = {
  crematorium?: Crematorium
  customerPostcode?: string | null
  onCrematoriumChanged: (crematorium: Crematorium) => void
  onReset: () => void
  boldHeader?: boolean
}

const CrematoriumPicker = ({
  crematorium,
  customerPostcode,
  onCrematoriumChanged,
  onReset,
  boldHeader = true,
}: CrematoriumPickerProps): ReactElement => {
  const [addressSearchValue, setAddressSearchValue] = useState<string>()
  const [addressSearchTrigger, setAddressSearchTrigger] = useState<number>()

  if (crematorium) {
    return (
      <Grid.Item>
        {boldHeader ? (
          <H size="XS">Chosen crematorium</H>
        ) : (
          <P>Chosen crematorium:</P>
        )}
        <CrematoriumDetails>
          <CrematoriumText>
            <CrematoriumName>{crematorium.name}</CrematoriumName>
            <CrematoriumAddress>{crematorium.address}</CrematoriumAddress>
          </CrematoriumText>
        </CrematoriumDetails>
        <Wrapper>
          <StyledInputMethodButton type="button" onClick={onReset}>
            Change location
          </StyledInputMethodButton>
        </Wrapper>
      </Grid.Item>
    )
  }

  return (
    <Grid.Item>
      <CrematoriumInput
        name="crematoriumSearch"
        searchValue={addressSearchValue}
        searchTrigger={addressSearchTrigger}
        onCrematoriumChanged={onCrematoriumChanged}
      />
      {customerPostcode && (
        <Wrapper margin={[GTR.S, 0, 0, 0]}>
          <StyledInputMethodButton
            type="button"
            onClick={() => {
              setAddressSearchValue(customerPostcode)
              setAddressSearchTrigger(Date.now())
            }}
          >
            Use customer postcode
          </StyledInputMethodButton>
        </Wrapper>
      )}
    </Grid.Item>
  )
}

export default CrematoriumPicker
